// extracted by mini-css-extract-plugin
export var billingAddress = "_rs-f";
export var contactInfo = "_rs-c";
export var customerInfoContainer = "_rs-b";
export var customerInfoRow = "_rs-9";
export var customerInfoSection = "_rs-a";
export var fullWidthDividerMobile = "_rs-g";
export var imageContainer = "_rs-1";
export var paymentMethod = "_rs-d";
export var priceText = "_rs-6";
export var priceTextMobile = "_rs-7";
export var product = "_rs-0";
export var productImage = "_rs-2";
export var productInfo = "_rs-4";
export var productTitle = "_rs-8";
export var quantityBadge = "_rs-3";
export var quantityText = "_rs-5";
export var shippingAddress = "_rs-e";